import React, { useContext, useEffect, useRef, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';

import { useLocation, useParams } from 'react-router-dom';

import { AddCandidateExperienceInfo, DeleteCandidateExperience, GetCandidate } from '../services/httpServices';

import styled from '@emotion/styled';
import { Trash } from 'react-feather';
import ModalLayout from 'src/theme/Modal';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
const CandidateExperienceInfo = (props) => {
  const location = useLocation();
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [candidate, setCandidate] = useState({});
  const [isCurrentJob, setIsCurrentJob] = useState(true);

  const companyNameRef = useRef('');
  const designationRef = useRef('');
  const startDateRef = useRef('');
  const endDateRef = useRef('');
  const companyContactRef = useRef('');
  const companyAddressRef = useRef('');
  const reasonOfLeavingRef = useRef('');

  const fetchCandidate = async (event) => {
    const candidate = await GetCandidate(id);

    setCandidate(candidate);
    setLoading(false);
  };
  useEffect(() => {
    fetchCandidate();
  }, [location]);

  const SaveCandidateEducation = async (event) => {
    setLoading(true);
    event.preventDefault();

    const payload = {
      companyName: companyNameRef.current.value,
      designation: designationRef.current.value,
      startDate: startDateRef.current.value,
      endDate: endDateRef.current.value,
      companyContact: companyContactRef.current.value,
      companyAddress: companyAddressRef.current.value,
      reasonOfLeaving: reasonOfLeavingRef.current.value,
      isCurrentJob: isCurrentJob,
    };

    let response = await AddCandidateExperienceInfo(id, payload);

    if (response.status == 200) {
      props.setMessage('Candidate saved successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let clientSaved = candidate;
      clientSaved.mstCandidateExperiences = response.data;
      setCandidate(clientSaved);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
    }
  };

  const deleteCandidateExperience = async (rowId) => {
    setLoading(true);
    event.preventDefault();
    let response = await DeleteCandidateExperience(rowId);
    if (response.status == 200) {
      props.setMessage('Candidate deleted successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let candidateSaved = candidate;
      candidateSaved.mstCandidateExperiences = response.data;
      setCandidate(candidateSaved);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
    }
  };
  const handleChangeIsCurrentJob = (event) => {
    setIsCurrentJob(event.target.value);
  };
  return (
    <>
      {' '}
      <Box
        p={4}
        component={Paper}
        marginTop={4}
        boxShadow={3}
        sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Experience Info
          </Typography>
        </Stack>
        <form onSubmit={SaveCandidateEducation}>
          {loading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" height="20vh" container>
              <CircularProgress size={60} thickness={3} value={100} />
            </Grid>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box component={Paper} p={1}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Name of Company"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={companyNameRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Designation"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={designationRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Company Contact"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={companyContactRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Start Date"
                        type="date"
                        required
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={startDateRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="End Date"
                        type="date"
                        required
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={endDateRef}
                      />
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Company Address"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        inputRef={companyAddressRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <TextField
                        label="Reason of Leaving"
                        required
                        variant="outlined"
                        fullWidth
                        size="small"
                        disabled={isCurrentJob == 'false' ? false : true}
                        inputRef={reasonOfLeavingRef}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <FormControl>
                        <FormLabel id="demo-controlled-radio-buttons-group">Is this Current Job:</FormLabel>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          onChange={handleChangeIsCurrentJob}
                          defaultValue={isCurrentJob}
                          row
                        >
                          <FormControlLabel value={true} control={<Radio />} label="Yes" />
                          <FormControlLabel value={false} control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={4} md={3}>
                      <Button type="submit" variant="contained">
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <br></br>
                <br></br>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Name of Campany</TableCell>
                        <TableCell>Designation</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>End Date</TableCell>
                        <TableCell>Company Contact</TableCell>
                        <TableCell>Company Address</TableCell>
                        <TableCell>Reason of Leaving</TableCell>
                        <TableCell>Is Current</TableCell>

                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {candidate?.mstCandidateExperiences?.map((row, index) => (
                        <TableRow key={index + 1}>
                          <TableCell>{row.companyName}</TableCell>
                          <TableCell>{row.designation}</TableCell>
                          <TableCell>{row.startDate?.split('T')[0]}</TableCell>
                          <TableCell>{row.endDate?.split('T')[0]}</TableCell>
                          <TableCell>{row.companyContact}</TableCell>
                          <TableCell>{row.companyAddress}</TableCell>
                          <TableCell>{row.reasonOfLeaving}</TableCell>
                          <TableCell>{row.isCurrentJob ? 'Yes' : 'No'}</TableCell>

                          <TableCell>
                            <ModalLayout
                              component={<Trash />}
                              description="Are You Sure you want to Delete?"
                              Hit={() => deleteCandidateExperience(row.id)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          )}
        </form>
      </Box>
    </>
  );
};

export default CandidateExperienceInfo;
